module.exports = __webpack_public_path__ + "img/coating-dirt-cover.1acbb47a.png";